import styled from "styled-components";
import { Select as ANTDSelect } from "antd";

export const AccountSelect = styled(ANTDSelect)`
    width: 100%;
    font-size: 14px;

    .ant-select-search__field {
        border-radius: unset;
        height: unset;
    }

    .ant-select-selection-search-input:focus {
        border-bottom: 1px solid #6b7384 !important;
    }

    .ant-select-selection-search {
        left: 0px !important;
    }

    .ant-select-selection-item {
        left: -11px !important;
    }

    .ant-select-selection {
        background-color: #e9ecf2;
        border: none;
        box-shadow: none;
    }

    .ant-select-selection__placeholder, .ant-select-search__field__placeholder {
        color: #6b7384;
    }

    .ant-select-selection__rendered {
        margin: 0 auto;
    }
`;

export const Body = styled.div`
    
`;

export const Main = styled.div`
    padding: 6px 16px;
    border-radius: 8px;
    background-color: #e9ecf2;
    width: 100%;

    border: ${props => props.hasError ? "solid 1px #f10b3c" : "none"};

    /* border: solid 1px #f10b3c; */

    label{
        font-size: 11px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.18;
        letter-spacing: normal;
        text-align: left;
        color: ${props => props.hasError ? "#f10b3c" : "#6b7384"};
        margin-bottom: 0px;
        display: block;
    }
`;

export const Alert = styled.div`
    span{
        display: ${props => props.message ? "block" : "none"};
        color: ${props => props.message ? "#f10b3c" : "#f10b3c"};
        font-size: 11px;
        margin: 6px 16px;
    }
`;